import React, { useState } from 'react';
import { saveAs } from 'file-saver';
import { IconButton, Tooltip } from '@mui/material';
import { CustomButton } from '../../CustomButton';
import { LinkOutlined } from '@mui/icons-material';
import packageJson from '../../../../package.json';

export const QrView = (props) => {

    const { data: { _id, qr }, action } = props;
    const [url, setUrl] = useState(qr?.url);
    const [tooltip, setTooltip] = useState('Copiar link');

    const copyLink = async () => {
        try {
            await navigator?.clipboard?.writeText(`${ packageJson?.proxy }/encuesta/${ _id }`);
            setTooltip('Copiado');
            setTimeout(() => setTooltip('Copiar link'), 2000);
        } catch (error) {
            console.log(error);
            throw Error(error);
        }
    }

    return (
        <div style={{ display: 'flex', flexFlow: 'column noWrap', justifyContent: 'center', alignItems: 'center', width: 320, height: 320, position: 'relative' }}>
            {
                !url ? (
                    <div style={{ width: 150, height: 150, border: '2px dashed #bdbdbd', background: '#ebebeb', borderRadius: 4, marginBottom: 15 }} />
                ) : <img src={ url } alt="qrcode" width={150} height={150} style={{ marginBottom: 15 }} />
            }
        
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 10 }}>
                { !url ? <CustomButton name='Generar' action={ async() => setUrl(await action(_id)) } /> : <CustomButton name='Descargar' action={ () => saveAs(url, 'qrcode.png') } /> }
                
                <Tooltip title={ tooltip }>
                    <IconButton size='medium' onClick={ copyLink }>
                        <LinkOutlined fontSize='medium' />
                    </IconButton>
                </Tooltip>
            </div>     
        </div>
    )
}